import uniqBy from 'lodash/uniqBy'
import { TypedTypePolicies } from './types-helpers'

const typePolicies: TypedTypePolicies = {
  Conversation: {
    fields: {
      messages: {
        keyArgs: ['id'],
        merge(existing = [], incoming) {
          return uniqBy([...existing, ...incoming], '__ref')
        },
      },
    },
  },
  Query: {
    fields: {
      Profile: {
        keyArgs: [],
        merge(existing = {}, incoming) {
          return { ...existing, ...incoming }
        },
      },
      Conversations: {
        keyArgs: [],
        merge(existing = [], incoming) {
          return uniqBy([...existing, ...incoming], '__ref')
        },
      },
    },
  },
}

export default typePolicies
